(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/correct-row.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/correct-row.js');

'use strict';

svs.numbergames.results.views.CorrectRow = Marionette.View.extend({
  ballRow: undefined,
  regions: {
    correctRowRegion: '#correctRowRegion'
  },
  ui: {
    sortSelect: '.js-sort-select'
  },
  triggers: {
    'change @ui.sortSelect': 'changeSorting'
  },
  template(data) {
    return svs.numbergames.results.templates.correct_row(data);
  },
  templateContext() {
    return {
      radioGroupName: "ng-sort-numbers-".concat(this.model.get('productId').toLowerCase(), "-").concat(this.model.has('type') ? this.model.get('type') : '')
    };
  },
  initialize() {
    var _svs$tur$ball$row$res;
    const branding = svs.numbergames.productMapping.getProductName(this.model.get('productId'));
    const BallRow = (_svs$tur$ball$row$res = svs.tur.ball.row.result[branding]) !== null && _svs$tur$ball$row$res !== void 0 ? _svs$tur$ball$row$res : svs.tur.ball.row.result.Default;
    this.ballRow = new BallRow({
      numbers: this.model.get('numbers'),
      extraNumbers: this.model.get('numbersExtra'),
      kungKeno: this.model.get('kungKenoNumber')
    });
  },
  onRender() {
    this.showChildView('correctRowRegion', {
      template: () => this.ballRow.render()
    });
  },
  onAttach() {
    if (this.model.get('productId') !== 'JOKER') {
      this.triggerMethod('change:sorting');
    }
  },
  onChangeSorting(view) {
    let {
      target: {
        value = 'NUMERICAL'
      } = {}
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const sortOrder = svs.tur.ball.row.sorter.constants[value];
    this.ballRow.sort(sortOrder);
  }
});

 })(window);